<template>
  <section class="grad-dark d-print-none">
    <div class="container">
      <div class="row">
        <ul class="nav roi-nav font-main font-weight-bold">
          <li
            v-for="step in calculatorSteps"
            :key="step.codeName"
            class="nav-item"
          >
            <a
              class="nav-link"
              href="#"
              :class="{
                active: currentStep && currentStep.codeName === step.codeName,
              }"
              :title="step.shortName || step.displayName"
              @click.prevent="onStepClick(step)"
            >
              <span class="link-icon">
                <img :src="step.imagePath" :alt="step.displayName" />
              </span>
              <span class="link-words">
                {{ step.shortName || step.displayName }}
              </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mutation } from '../store';

export default {
  name: 'StepsNavigation',

  computed: {
    ...mapGetters(['steps', 'currentStep']),

    /** @returns {Step[]} */
    calculatorSteps() {
      return this.steps;
    },
  },

  methods: {
    /**
     * @param {Step} step
     */
    onStepClick(step) {
      this.$store.commit(mutation('SET_CURRENT_STEP'), step);
    },
  },
};

/**
 * @typedef {import('../store/state').Step} Step
 */
</script>
